import * as React from "react";

function SvgGist(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M21.246 12.791c1.813 0 3.56.12 5.223.36.008-.21.013-.418.013-.624a5.242 5.242 0 00-5.236-5.237 5.242 5.242 0 00-5.237 5.236c0 .207.005.415.013.624a36.928 36.928 0 015.224-.359m-3.47 7.46a30.269 30.269 0 001.569 3.101 30.266 30.266 0 001.9 2.91 30.227 30.227 0 001.901-2.91 30.322 30.322 0 001.569-3.1 30.25 30.25 0 00-3.47-.192 30.25 30.25 0 00-3.469.192m-7.027 2.032a15.04 15.04 0 00-.547.3 5.243 5.243 0 00-1.916 7.153 5.258 5.258 0 004.543 2.62c.91 0 1.813-.243 2.61-.703.178-.103.356-.211.533-.324a36.808 36.808 0 01-2.922-4.343 36.83 36.83 0 01-2.301-4.703m15.77 9.046c.177.113.355.22.533.324.797.46 1.7.703 2.61.703 1.87 0 3.61-1.004 4.543-2.62a5.2 5.2 0 00.523-3.973 5.202 5.202 0 00-2.44-3.18c-.178-.103-.36-.203-.546-.3a36.77 36.77 0 01-2.3 4.703 36.696 36.696 0 01-2.923 4.343m3.143 8.296c-2.185 0-4.344-.58-6.244-1.677a22.965 22.965 0 01-2.172-1.427c-.708.523-1.434 1-2.173 1.427a12.507 12.507 0 01-6.244 1.677 12.549 12.549 0 01-10.838-6.254C-1.457 27.4.596 19.737 6.568 16.29c.74-.428 1.515-.817 2.322-1.169-.1-.874-.15-1.74-.15-2.595C8.74 5.631 14.35.022 21.246.022c6.895 0 12.505 5.61 12.505 12.504 0 .854-.05 1.72-.15 2.595.807.352 1.583.741 2.322 1.169a12.422 12.422 0 015.826 7.593 12.421 12.421 0 01-1.249 9.489 12.548 12.548 0 01-10.838 6.254"
          fill="#00D2FF"
        />
        <path
          d="M24.714 20.253c2.68.307 5.033.985 7.029 2.031.972-2.425 1.594-4.818 1.86-7.163-2.164-.942-4.547-1.6-7.134-1.97-.092 2.25-.682 4.628-1.755 7.102m1.806 11.078c-1.904-1.205-3.668-2.905-5.274-5.071-1.606 2.166-3.37 3.866-5.273 5.071 1.614 2.055 3.375 3.79 5.273 5.192 1.898-1.402 3.66-3.137 5.274-5.192m-8.742-11.078c-1.073-2.474-1.663-4.852-1.755-7.103-2.587.37-4.97 1.029-7.133 1.971.265 2.345.887 4.738 1.86 7.164 1.995-1.046 4.349-1.725 7.028-2.032"
          fill="#20A6D6"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgGist);
